import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PipelineHealthFacade } from './pipeline-health.facade';
import { DashboardPageDefinition } from '../../dashboard.data';
import { DashboardVmState } from '../../domain/model/dashboard-vm.model';
import { PipelineCardVm, PipelineHealthVm } from '../../domain/model/pipeline-health.model';

/** Pipeline health page: three derived-rate cards over the seven-bar funnel, both following the shared filters. */
@Component({
  selector: 'ifbp-pipeline-health',
  templateUrl: './pipeline-health.component.html',
  styleUrls: ['./pipeline-health.component.scss'],
  providers: [PipelineHealthFacade],
  standalone: false,
})
export class PipelineHealthComponent implements OnInit {
  page$: Observable<DashboardPageDefinition>;
  vm$: Observable<PipelineHealthVm>;
  readonly VmState = DashboardVmState;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly facade: PipelineHealthFacade,
  ) {}

  ngOnInit(): void {
    this.page$ = this.route.data.pipe(map((data: Data) => data.dashboardPage as DashboardPageDefinition));
    this.vm$ = this.facade.vm$;
  }

  /** The three cards are fixed and distinct; their titles are the stable key. */
  trackByCard(_index: number, card: PipelineCardVm): string {
    return card.title;
  }
}
